import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/units/')({
  component: () => (
    <EmptyState icon="server" title="Выбери юнит" description="Слева — список юнитов флота" />
  ),
})
